import { Address, Policy } from '@amfam/policy/models';
import { PolicyChangeRequestType } from '@amfam/shared/models';

import { AddressChange, ChangeRequest } from './change-request.model';

export class ChangerequestInternalEmail {
  public policyList: Policy[];
  public firstName: string;
  public lastName: string;
  public address: Address;
  public email: string;
  public phone: string;
  public comment: string;
  public policyChangeType: PolicyChangeRequestType;
  public risksDescription?: string;
  public requestedChange: string;
  public currentLenderName?: string;
  public newLenderName?: string;
  public lenderToBeRemoved?: string;
  public addLenderName?: string;
  public selectedPolicyNumber?: string;
  public addressChange?: AddressChange;

  constructor(changeRequest: ChangeRequest) {
    this.policyList = changeRequest.policyList;
    this.firstName = changeRequest.firstName;
    this.lastName = changeRequest.lastName;
    this.address = changeRequest.address;
    this.email = changeRequest.email;
    this.phone = changeRequest.phone;
    this.comment = changeRequest.comment;
    this.policyChangeType = changeRequest.policyChangeType;
    this.risksDescription = changeRequest.riskDescription;
    this.requestedChange = changeRequest.requestedChange;
    this.currentLenderName = changeRequest.currentLenderName;
    this.newLenderName = changeRequest.newLenderName;
    this.lenderToBeRemoved = changeRequest.lenderToBeRemoved;
    this.addLenderName = changeRequest.addLenderName;
    this.selectedPolicyNumber = changeRequest.selectedPolicyNumber;
    this.addressChange = changeRequest.addressChange;
  }
}
